import { Card, Result, Row, Typography,Col, Button } from 'antd'
import React from 'react'
import { ArrowLeftOutlined } from '@ant-design/icons'
import { NavLink, useLocation } from 'react-router-dom'
import { FooterHandler } from '../Footer/Footer'
import ErrorPage from '../../pages/ErrorPages/ErrorPage'

const GuestPurchaseSuccess = () => {
    const location = useLocation()
    // const fromConfirm = location?.state?.fromConfirm || false
    const query = new URLSearchParams(window.location.search);
    const state = query.get('state');
    const type = query.get('type')
    const ref = query.get('ref')
    const email = query.get('email')
    // console.log("from", state, type);
    // const location = window.location.origin

    // console.log(`Activation Success Component is showing:`, location)
    // const isFromConfirmation = location?.state?.iFromConfirmation
    if (state) {
        return (
            <>
                <>
                    <Row justify='center' align='middle' style={{ backgroundColor: 'white', minHeight: '100vh' }}>
                        <Col span={24} style={{ position: 'absolute', top: '14vh', left: '1vw', zIndex: 10, }}>
                            <NavLink to="/welcome">
                                <Button type="text" icon={<ArrowLeftOutlined />}>
                                    Back to Home
                                </Button>
                            </NavLink>
                        </Col>
                        <Card
                            style={{
                                background: 'white',
                                width: 600,
                                boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                                marginTop: "-56px"
                            }}
                        >
                            <Result
                                status='success'
                                title='Thanks for your purchase!'
                                subTitle={`Reference ID: ${ref}`}
                                extra={
                                    <Row style={{ margin: '8px 0' }} justify={'center'}>
                                        <Typography>An email containing your license key has been sent to <text style={{ color: "#1E90FF" }}>{email}</text>. If you don’t see it in your inbox, please check your spam or email quarantine folders.
                                            If you still can’t find it, feel free to contact us at jayson.amodia@lasermet.com or kobe.balansag@lasermet.com.

                                        </Typography>
                                        {/* <NavLink to='/login'>Click here to login</NavLink> */}
                                    </Row>
                                }
                            />
                        </Card>
                    </Row>



                    {/* <Flex justify='center' style={{ width: "100%", minHeight: "100vh" }}>
    
                </Flex> */}
                    <FooterHandler />
                </>
            </>
        )
    } else {
        return <ErrorPage />
    }

}

export default GuestPurchaseSuccess